import React from 'react'
import {Icon} from '@chakra-ui/react'

const BurgerIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path d="M24 19V21H0V19H24ZM24 11V13H0V11H24ZM24 3V5H0V3H24Z" fill="currentColor" />
        </Icon>
    )
}

export default BurgerIcon
